module.exports = "images/loading.svg"